import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-task-type-modal',
  templateUrl: './task-type.component.html',
  styleUrls: ['./task-type.component.scss'],
})
export class TaskTypeModalComponent {
  selectedType: 'task' | 'feed' | null = null;
  isTypeSelected: boolean = false;

  constructor(private dialogRef: MatDialogRef<TaskTypeModalComponent>) {}

  select(type: 'task' | 'feed') {
    this.selectedType = type;
    this.isTypeSelected = true;
  }

  continue() {
    if (!this.selectedType) return;
    this.dialogRef.close(this.selectedType);
  }

  onClose() {
    this.dialogRef.close('close');
  }
}
